import React from "react";
import editIcon from "../../assets/edit_icon.png"; 

/**
 * SongTile Component
 * Displays a song's artwork, title, and optional edit controls.
 * Compliance verification overlays have been removed to allow direct playback.
 */
const SongTile = ({
  song,
  onClick,
  isInteractive = false,
  showEdit = false,
  onEdit = () => {}
}) => {
  if (!song) return null;

  const { title, albumArtworkURL } = song;

  const handleTileClick = (e) => {
    if (onClick) {
      onClick(e); // Trigger normal audio playback queue streaming
    }
  };

  return (
    <div
      onClick={handleTileClick}
      className={`aspect-square rounded-lg overflow-hidden shadow-md relative group ${
        isInteractive ? "cursor-pointer hover:scale-105 transition-transform" : ""
      }`}
    >
      {/* Album Artwork */}
      <img
        src={albumArtworkURL || "https://via.placeholder.com/300?text=No+Artwork"}
        alt={title}
        className="object-cover w-full h-full"
      />

      {/* Song Title Overlay */}
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-2 z-10">
        <p className="text-white text-sm font-semibold drop-shadow-md truncate text-center">
          {title}
        </p>
      </div>

      {/* Edit Icon (for artist owner view) */}
      {showEdit && (
        <img
          src={editIcon}
          alt="Edit"
          className="absolute top-2 right-2 w-5 h-5 cursor-pointer opacity-80 hover:opacity-100 z-10"
          onClick={(e) => {
            e.stopPropagation();
            onEdit(song);
          }}
        />
      )}
    </div>
  );
};

export default SongTile;